import { Injectable } from '@angular/core';
import { PscHttpService } from './psc-http.service';
import { PaymentStatusResponse } from '../common/models/payment/payment-status-response';
import { map, Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { PaymentType } from '../common/models/payment/payment-type';
import { SubscriptionInfo } from '../common/models/payment/subscription-info';
import { Transaction } from '../common/models/payment/transaction';
import { UserRole } from '../common/models/user/user-role.enum';
import { UpdateSubscriptionResponse } from '../common/models/payment/update-subscription-response';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {

  baseEndpoint = 'payment/';

  constructor(
    private httpService: PscHttpService,
  ) {
  }

  getPaymentStatus(sessionId: string): Observable<PaymentStatusResponse> {
    return this.httpService.get(`${ this.baseEndpoint }${ sessionId }`);
  }

  getSubscriptionInfo(): Observable<SubscriptionInfo> {
    return this.httpService.get(`${ this.baseEndpoint }subscription`);
  }

  getTransactions(): Observable<Transaction[]> {
    return this.httpService.get(`${ this.baseEndpoint }transactions`);
  }

  cancelSubscription() {
    return this.httpService.get(`${ this.baseEndpoint }subscription/cancel`);
  }

  updateSubscription(newRole: UserRole): Observable<UpdateSubscriptionResponse> {
    return this.httpService.put(`${ this.baseEndpoint }subscription/update`, { subscriptionType: newRole });
  }

  getBill(paymentId: string) {
    return this.httpService.getReturnPdf(`${ this.baseEndpoint }bill/${ paymentId }`).pipe(
      map(result => result as unknown as Blob),
    );
  }

  getAnalysisPaymentStripeUrl(paymentType: PaymentType.HomeAnalysis | PaymentType.EnterpriseAnalysis, userId: string, analysisId: string, prefilled_email: string) {
    return this.getStripeUrl(paymentType, `${ userId }-${ analysisId }`, prefilled_email);
  }

  getSubscriptionStripeUrl(paymentType: PaymentType.BusinessSubscription | PaymentType.BusinessPlusSubscription, userId: string, prefilled_email: string) {
    return this.getStripeUrl(paymentType, `${ userId }`, prefilled_email);
  }

  getStripeUrl(paymentType: PaymentType, client_reference_id: string, prefilled_email: string) {
    return `${ this.baseUrlFromType(paymentType) }?client_reference_id=${ client_reference_id }&prefilled_email=${ prefilled_email }`;
  }

  private baseUrlFromType(type: PaymentType): string {
    switch (type) {
      case PaymentType.HomeAnalysis:
        return environment.stripeUrls.homeAnalysis;
      case PaymentType.EnterpriseAnalysis:
        return environment.stripeUrls.enterpriseAnalysis;
      case PaymentType.BusinessSubscription:
        return environment.stripeUrls.businessSubscription;
      case PaymentType.BusinessPlusSubscription:
        return environment.stripeUrls.businessPlusSubscription;
    }
  }
}
